import { TReduxActions } from '../../actions';
import { EListingOffersActionType, ELoadListingActionTypes } from '../../actions/listingOffers';
import { EAddToFavoritesActionTypes } from '../../actions/newFavorites/addToFavorite';
import { ERemoveFromFavoritesActionTypes } from '../../actions/newFavorites/removeFromFavorite';
import { EFetchStatus, IListingOffersState } from '../../types/listingOffers';
import { patchOfferFavorite } from '../../utils/patchOfferFavorite';

const OFFERS_PER_PAGE = 28;

const defaultSeoSchemas = {
  mortgageDiscount: '',
  onlineShow: '',
  organizationInfo: '',
  product: '',
  wideSelection: '',
};

export const defaultState: IListingOffersState = {
  offers: [],
  page: 1,
  maxOffersCount: OFFERS_PER_PAGE,
  currentOffersCount: 0,
  status: EFetchStatus.INITIAL,
  mlRanking: null,
  seoData: {
    markedList: { items: [] },
    seoSchemas: defaultSeoSchemas,
  },
  breadcrumbs: null,
  hasMoreOffers: false,
  puids: null,
  sortVariants: [],
};

export function listingOffersReducer(
  state: IListingOffersState = defaultState,
  action: TReduxActions,
): IListingOffersState {
  switch (action.type) {
    case EListingOffersActionType.RemoveOffers: {
      return { ...state, maxOffersCount: OFFERS_PER_PAGE, currentOffersCount: 0, offers: [], mlRanking: null };
    }
    case EListingOffersActionType.MarkEmpty: {
      return {
        ...state,
        status: EFetchStatus.SUCCESS,
        maxOffersCount: OFFERS_PER_PAGE,
        currentOffersCount: 0,
        offers: [],
        mlRanking: null,
        hasMoreOffers: false,
      };
    }
    case EListingOffersActionType.SetPage: {
      return { ...state, page: action.payload };
    }
    case ELoadListingActionTypes.Request: {
      if (action.payload.reset) {
        return {
          ...state,
          status: EFetchStatus.LOADING,
          offers: [],
          currentOffersCount: 0,
          mlRanking: null,
        };
      }

      return { ...state, status: EFetchStatus.LOADING };
    }
    case ELoadListingActionTypes.Success: {
      return {
        ...state,
        status: EFetchStatus.SUCCESS,
        maxOffersCount: action.payload.offersCount,
        currentOffersCount: action.payload.offers.length,
        offers: action.payload.offers,
        mlRanking: action.payload.mlRanking,
        seoData: action.payload.seoData,
        breadcrumbs: action.payload.breadcrumbs,
        hasMoreOffers: action.payload.offersCount >= OFFERS_PER_PAGE,
        puids: action.payload.puids ?? state.puids,
        sortVariants: action.payload.sortVariants,
      };
    }
    case ELoadListingActionTypes.Failure: {
      return { ...defaultState, status: EFetchStatus.FAILURE };
    }

    case ERemoveFromFavoritesActionTypes.Success:
    case EAddToFavoritesActionTypes.Success: {
      const offers = patchOfferFavorite(state.offers, action.payload.offerId, action.payload.isFavorite);

      return offers === state.offers ? state : { ...state, offers };
    }
  }

  return state;
}
